import { render, staticRenderFns } from "./Leases.vue?vue&type=template&id=bc30c2ce&scoped=true&"
import script from "./Leases.vue?vue&type=script&lang=js&"
export * from "./Leases.vue?vue&type=script&lang=js&"
import style0 from "./Leases.vue?vue&type=style&index=0&id=bc30c2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30c2ce",
  null
  
)

export default component.exports